import AddLinkDialog from './AddLinkDialog'
import { connect } from 'react-redux'
import { taskLinkAdd } from '../../store/taskLinks'

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = (dispatch, ownProps) => ({
  addLink: (url, name) => {
    dispatch(taskLinkAdd(ownProps.task.id, name, url))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AddLinkDialog)



// WEBPACK FOOTER //
// ./src/components/AddLinkDialog/index.js